var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 33.3332C5.74992 33.3332 4.9652 33.0068 4.31242 32.354C3.65964 31.7012 3.33325 30.9165 3.33325 29.9998V9.99984C3.33325 9.08317 3.65964 8.29845 4.31242 7.64567C4.9652 6.99289 5.74992 6.6665 6.66659 6.6665H33.3333C34.2499 6.6665 35.0346 6.99289 35.6874 7.64567C36.3402 8.29845 36.6666 9.08317 36.6666 9.99984V29.9998C36.6666 30.9165 36.3402 31.7012 35.6874 32.354C35.0346 33.0068 34.2499 33.3332 33.3333 33.3332H6.66659ZM19.9999 21.3748C20.1388 21.3748 20.2846 21.354 20.4374 21.3123C20.5902 21.2707 20.736 21.2082 20.8749 21.1248L32.6666 13.7498C32.8888 13.6109 33.0555 13.4373 33.1666 13.229C33.2777 13.0207 33.3333 12.7915 33.3333 12.5415C33.3333 11.9859 33.0971 11.5693 32.6249 11.2915C32.1527 11.0137 31.6666 11.0276 31.1666 11.3332L19.9999 18.3332L8.83325 11.3332C8.33325 11.0276 7.84714 11.0207 7.37492 11.3123C6.9027 11.604 6.66659 12.0137 6.66659 12.5415C6.66659 12.8193 6.72214 13.0623 6.83325 13.2707C6.94436 13.479 7.11103 13.6387 7.33325 13.7498L19.1249 21.1248C19.2638 21.2082 19.4096 21.2707 19.5624 21.3123C19.7152 21.354 19.861 21.3748 19.9999 21.3748Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.dfb673d70144955e9e7794ac3e357bdc.svg";
export { ForwardRef as ReactComponent };